import { Component, NgZone } from "@angular/core";
import { Platform, ToastController, LoadingController, AlertController } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

import { AuthService } from "../services/AuthService";
import { UserService } from "../services/UserService";
import { DownloadService } from "../services/DownloadService";

import { TabsPage } from "../pages/tabs/tabs";
//import { DetermineFirstPage } from "../pages/determine-first/determine-first";
import { FirestoreService } from "../services/FirestoreService";
import { OneSignal } from '@ionic-native/onesignal';
import { HttpClient } from "@angular/common/http";

@Component({
  templateUrl: "app.html"
})
export class MyApp {
  rootPage: any = 'DetermineFirstPage';

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private authService: AuthService,
    private userService: UserService,
    private oneSignal: OneSignal,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private firestoreService: FirestoreService,
    private downloadService: DownloadService,
    private alertCtrl: AlertController,
    private httpClient: HttpClient,
    private zone: NgZone
  ) {


    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleLightContent();
      localStorage.setItem('runOrangeCron', '0');
      this.splashScreen.hide();

      let orangeCron = setInterval(() => {
        let alert = this.alertCtrl.create({
          title: "Orange Payment",
          subTitle: "Your subscription is now active",
          buttons: ["Dismiss"]
        });


        let runOrangeCron = localStorage.getItem('runOrangeCron');

        if (runOrangeCron == '1') {
          let pay_token = localStorage.getItem('orangePayToken');
          let token = localStorage.getItem('orangeToken');
          let order_id = localStorage.getItem('orangeOrderId');

          let that = this;

          if (pay_token == null || pay_token == undefined || pay_token == '') {
            //
          } else {
            this.httpClient.post('https://payments.qiinii.com/qiinii_orange_status.php', {
              token,
              order_id,
              pay_token
            }).subscribe(function (data: any) {

              console.log(data);

              if (data.status !== undefined) {
                if (data.status == 'SUCCESS') {

                  let pendingEmail = localStorage.getItem('pendingEmail');
                  let pendingPassword = localStorage.getItem('pendingPassword');


                  that.authService
                    .registerOrangeUser(
                      pendingEmail,
                      pendingPassword,
                    )
                    .then(x => {
                      let regUserUID = localStorage.getItem('regUserUID');

                      /************************************** */
                      that.httpClient.get(`https://payments.qiinii.com/p_fetch.php?uid=${regUserUID}&email=${pendingEmail}`).subscribe(function (data: any) {

                        console.log(data);

                        if (data.success) {
                          that.firestoreService.updateOrangePayment(data.data.notif_token, data.data.payment_date);
                          that.firestoreService.updateOrangePaymentHistory(data.data);
                          alert.present();
                          localStorage.removeItem('runOrangeCron');
                          localStorage.removeItem('pendingEmail');
                          localStorage.removeItem('pendingPassword');

                          clearInterval(orangeCron);
                        } else {
                          console.log('something wrong');
                        }


                      });
                      /************************************* */


                      let alert = that.alertCtrl.create({
                        title: "Thank You",
                        subTitle: "Registration was successful. Please verify your email address to access your account!",
                        buttons: ["Dismiss"]
                      });

                      alert.present();

                      this.navCtrl.setRoot("SignInPage");
                    })
                    .catch(error => {

                      //
                    });
                }
              }
            });

          }

        }



        //alert.present()
      }, 3000);

      this.oneSignal.handleNotificationReceived().subscribe(data => {
        // do something when notification is received
        console.log(JSON.stringify(data));
        //alert(JSON.stringify(data));
        let t = toastCtrl.create({
          message: 'You have 1 new notification',
          cssClass: "toast-success",
          duration: 5000,
          showCloseButton: true,
          closeButtonText: 'View'
        })

        t.present()

        t.onDidDismiss(() => {
          this.presentLoadingDefault()
          //this.nav.push(data.page);
        });

        setTimeout(() => {
          t.onDidDismiss(() => {
            //Do nothing......!
          });
        }, 4000);



      });

      this.oneSignal.handleNotificationOpened().subscribe(data => {
        console.log(JSON.stringify(data));
        //alert(JSON.stringify(data));

        let t = toastCtrl.create({
          message: 'You have 1 new notification',
          cssClass: "toast-success",
          duration: 5000,
          showCloseButton: true,
          closeButtonText: 'View'
        })

        t.present()

        t.onDidDismiss(() => {
          this.presentLoadingDefault()
          //this.nav.push(data.page);
        });

        setTimeout(() => {
          t.onDidDismiss(() => {
            //Do nothing......!
          });
        }, 4000);
      });

      this.oneSignal.getIds().then((data) => {
        console.log(JSON.stringify(data));
        let token = data.pushToken;

        console.log(token);
        /*
        this.list.updatePushToken(this.loggedInUserName, token).subscribe((data) => {
          console.log(JSON.stringify(data));
        }, (err) => {
          console.error(JSON.stringify(JSON.stringify(err)))
        });
        */
        localStorage.setItem('loggedInPushToken', token);
      }).catch((err) => {
        console.error(err);
      });


      this.oneSignal
        .startInit('1c5c9a64-adab-42f0-8b57-be0d116f2f86', '637064429236')
        .inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None)
        .handleNotificationOpened(receivedData => {
          // alert(JSON.stringify(receivedData));
          let notification_title = receivedData.notification.payload.title;
          let notification_message = receivedData.notification.payload.body;
          let notification_link = receivedData.notification.payload.additionalData.link; //Custom link
          let notification_description =
            receivedData.notification.payload.additionalData.description; //Custom description
          let notification_image =
            receivedData.notification.payload.additionalData.image; //Custom image


          if (notification_link == undefined || notification_link == null || notification_link == '' || notification_link == 'null') {
            // this.openRootPageInTab(4)
          } else {
            // app.getRootNav().push(notification_link);
          }

        })
        .handleNotificationReceived(function (receivedData) {
          // do something when notification is received
          //alert(JSON.stringify(receivedData));

          let notification_title = receivedData.payload.title;
          let notification_message = receivedData.payload.body;
          let notification_link = receivedData.payload.additionalData.link; //Custom link
          let notification_description =
            receivedData.payload.additionalData.description; //Custom description
          let notification_image =
            receivedData.payload.additionalData.image; //Custom image


          let t = toastCtrl.create({
            message: 'You have 1 ' + notification_link + ' notification',
            cssClass: "toast-success",
            duration: 5000,
            showCloseButton: (notification_link == undefined || notification_link == null || notification_link == '' || notification_link == 'null') ? false : true,
            closeButtonText: 'View'
          })

          t.present()

          t.onDidDismiss(() => {
            //app.getRootNav().push(notification_link);
          });

          setTimeout(() => {
            t.onDidDismiss(() => {
              //Do nothing......!
            });
          }, 4000);
          console.log(JSON.stringify(receivedData));
          //alert(JSON.stringify(receivedData.notification.payload));
        })
        .endInit();
    });

    let uid = localStorage.getItem('loggedInUserUID')

    this.downloadService.load();

    this.authService.afAuth.authState.subscribe((user: firebase.User) => {
      console.log(user);

      if (user && (uid !== null)) {
        console.log('--------------');
        console.log(user.emailVerified)
        console.log('--------------');

        if (user.emailVerified) {

          //Check subscription
          this.firestoreService.checkIfSubscribed(user.uid).catch((res) => {


            if (res.isSubscribed) {
              this.userService.addUser(user);

              this.zone.run(() => {
                this.rootPage = TabsPage;
              });

            }
          })

        }
      }
    }, error => {
      console.log('User null :>> ');
      console.error(JSON.stringify(error));
    });
  }

  presentLoadingDefault() {
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    setTimeout(() => {
      loading.dismiss();
    }, 5000);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts